import React, { FC, memo } from 'react';

import { ModalProps, ModalTypes } from 'application/providers/ModalProvider';
import { selectAcceptanceAdvancedLink, setAcceptanceAdvancedTab } from 'application/store';
import { useAccountCompanyId } from 'application/hooks';
import { useAppDispatch, useAppSelector } from 'application/providers/StoreProvider';

import ModalScreen from '@zvuk-b2b/react-uikit/ui/ModalScreen';
import Button, { ButtonType } from '@zvuk-b2b/react-uikit/ui/Button';

import { TEXTS } from './texts';

import styles from './index.module.scss';

const SberBusinessOpenModal: FC<ModalProps[ModalTypes.SBERBUSSINESS_OPEN]> = ({ close }) => {
  const dispatch = useAppDispatch();
  const acceptanceAdvancedLink = useAppSelector(selectAcceptanceAdvancedLink());
  const companyId = useAccountCompanyId();

  const handleOpen = () => {
    const openedWindow = window.open(acceptanceAdvancedLink, '_blank');
    dispatch(setAcceptanceAdvancedTab({ companyId, openedWindow }));
    close();
  };

  return (
    <ModalScreen
      title={TEXTS.MODAL_TITLE}
      titlePlacement="left"
      onClose={close}
      actionButtons={[
        <Button
          key="button_sber_business_open__modal"
          elementId="button_sber_business_open__modal"
          type={ButtonType.PRIMARY}
          onClick={handleOpen}>
          {TEXTS.MODAL_BUTTON_TEXT}
        </Button>,
      ]}>
      <div className={styles.description}>{TEXTS.MODAL_DESCRIPTION}</div>
    </ModalScreen>
  );
};

export default memo(SberBusinessOpenModal);
